// extracted by mini-css-extract-plugin
export default {"send-button":"styles_send-button__p0kGb","title":"styles_title__VPgNh"};